import {Component, signal} from '@angular/core';
import {CodaltComponent} from '../codalt.component';
import {MatCheckbox} from '@angular/material/checkbox';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {DatePipe, PercentPipe} from '@angular/common';
import {Clipboard} from '@angular/cdk/clipboard';
import {UrlPrefixStrippingPipe} from '../pipes/url-prefix-stripping.pipe';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    imports: [
        MatCheckbox,
        ReactiveFormsModule,
        DatePipe,
        PercentPipe,
        UrlPrefixStrippingPipe
    ]
})
export class ProfileComponent extends CodaltComponent {

    showOwnMail = new FormControl(false);
    readonly urlCopied = signal<boolean>(false);
    readonly urlCopiedOwn = signal<boolean>(false);

    constructor(private clipboard: Clipboard) {
        super();
    }

    copyUrlShare(onlyMe = false) {
        if (this.clipboard.copy(this.environment.apiEndpoint + 'ical/' + this.LocalStorage.user.calendarUrl + (onlyMe ? '?onlyMe=true' : ''))) {
            if (onlyMe) {
                this.urlCopiedOwn.set(true);
            } else {
                this.urlCopied.set(true);
            }
            setTimeout(() => {
                this.urlCopiedOwn.set(false);
                this.urlCopied.set(false);
            }, 5000);
        }
    }
}

